import React from 'react'

import { UploadedFile } from 'openapi/models/UploadedFile'

import Citation from 'components/ui/citation'

import {
  computeReferenceKey,
  ReferenceWithFile,
} from '../../../file-previewer/utils/helpers'
import { TextWithReferences } from '../../utils/office'

interface OrderedCitationsProps {
  textWithReferences: TextWithReferences
  referenceIndices: Record<string, number>
  referencesToFiles: Record<string, UploadedFile>
  openDialog: (selectedReference: ReferenceWithFile | null) => void
}

export const OrderedCitations = ({
  textWithReferences,
  referenceIndices,
  referencesToFiles,
  openDialog,
}: OrderedCitationsProps) => {
  const citations = [...textWithReferences.references]
    // Keeps citation numbers in order -- they aren't necessarily sorted when they're added.
    .sort(
      (a, b) =>
        referenceIndices[computeReferenceKey(a)] -
        referenceIndices[computeReferenceKey(b)]
    )
    .map((reference) => {
      const citationKey = computeReferenceKey(reference)
      return (
        <Citation
          key={citationKey}
          onClick={() =>
            openDialog(
              referencesToFiles[citationKey]
                ? { reference, file: referencesToFiles[citationKey] }
                : null
            )
          }
        >
          {referenceIndices[citationKey]}
        </Citation>
      )
    })

  return <span className="flex gap-1">{citations}</span>
}
